import Delete from '@mui/icons-material/Delete';
import CircularProgress from '@mui/material/CircularProgress';
import IconButton from '@mui/material/IconButton';
import Paper from '@mui/material/Paper';
import Tooltip from '@mui/material/Tooltip';
import moment from "moment";
import { Component } from 'react';
import { connect } from 'react-redux';
import { confirmAction, showError, showMessage } from '../../actions/uiActions';
import EinApi from '../../api/eins';
import PaginatedTable from '../../components/PaginatedTable';
import { withRouter } from '../../utils/withRouter';
import ExclusionDeleteConfirmationModal from './exclusionDeleteConfirmationModal';
import { Fab } from '@mui/material';
import { Add } from '@mui/icons-material';
import AddUserToExclusionModal from './addUserToExclusionModal';

class Exclusions extends Component
{
    state = {
        loading: true,
        deleting: false,
        user: null,
        users: [],
        count: 0,
        page: 0,
        pages: 0,
        confirmExclusionDelete: false,
        sort: {},
        activeQuery: {
            order: 'desc', orderBy: 'censusExclusionDate'
        },
        add: false,
        addingUser: false,
    }


    componentDidMount()
    {
        this.getExcludedUsers(this.state.page);
    }

    getExcludedUsers = async (page, params) =>
    {
        try
        {
            const result = await EinApi.getExcludedUsers(this.props.match.params.domainId, page, { ...this.state.activeQuery, ...params })
            if (result)
            {
                this.setState({ loading: false, users: result.users, page: result.page, pages: result.pages, count: result.count })
            }
        } catch (error)
        {
            this.setState({ loading: false }, this.props.showError)
        }
    }

    openConfirmDeleteModal = (user) => this.setState({ user, confirmExclusionDelete: true })

    delete = () =>
    {
        const user = this.state.user
        this.setState({ deleting: true }, async () =>
        {
            if (user.excludedFromCensus)
            {
                try
                {
                    await EinApi.removeExcludedUser(user._id, this.props.match.params.domainId)
                    this.props.showMessage("User removed successfully");
                    this.setState({ deleting: false, user: null, confirmExclusionDelete: false })
                    this.getExcludedUsers();
                } catch (error)
                {
                    this.setState({ deleting: false, user: null }, this.props.showError(error || 'An error occured'))
                }
            } else
            {
                this.props.showMessage("User is not in the exclusion list");
                this.setState({ deleting: false, user: null, })
            }
        })
    }

    addUser = () =>
    {
        this.setState({ addingUser: true }, async () =>
        {
            if (this.state.email)
            {
                try
                {
                    await EinApi.addUserToCensusExclusionList({ email: this.state.email, domainId: this.props.match.params.domainId })
                    this.props.showMessage("User added successfully");
                    this.setState({ addingUser: false, email: null, add: false })
                    this.getExcludedUsers();
                } catch (error)
                {

                    this.setState({ addingUser: false }, this.props.showError(error || 'An error occured'))
                }

            }
        })
    }

    handleSort = ({ order, orderBy }) =>
    {
        this.setState(
            { sort: { ...this.state.sort, [orderBy]: order }, activeQuery: { order, orderBy } }, () => this.getExcludedUsers(this.state.page, { order, orderBy })
        );
    }

    render()
    {
        return (
            <div className='position-relative'>
                <div className="row">
                    <div className="col-12">
                        <Paper>
                            <PaginatedTable goToPage={this.getExcludedUsers} count={parseInt(this.state.count.toString())} page={parseInt(this.state.page.toString())} loading={this.state.loading} rows={this.state.users.map(user =>
                            {
                                return {
                                    properties: {
                                        key: user._id
                                    },
                                    columns:
                                        [
                                            {
                                                properties: {
                                                    key: `${user._id}-1`
                                                },
                                                value: user.firstname
                                            },
                                            {
                                                properties: {
                                                    key: `${user._id}-2`
                                                },
                                                value: user.lastname
                                            },
                                            {
                                                properties: {
                                                    key: `${user._id}-3`
                                                },
                                                value: user.email
                                            },
                                            {
                                                properties: {
                                                    key: `${user._id}-4`
                                                },
                                                value: user.secondary_email
                                            },
                                            {
                                                properties: {
                                                    key: `${user._id}-5`
                                                },
                                                value: user.employerKey
                                            },
                                            {
                                                properties: {
                                                    key: `${user._id}-6`
                                                },
                                                value: moment.unix(user.censusExclusionDate).format("MM/DD/YYYY")
                                            },
                                            {
                                                properties: {
                                                    key: `${user._id}-7`
                                                },
                                                value: <div className="text-centers">
                                                    {this.state.user && this.state.user._id === user._id ? <CircularProgress size={24} /> :
                                                        <>
                                                            <Tooltip title="Delete terminated user">
                                                                <IconButton disabled={this.state.deleting && this.state.user && this.state.user?._id === user?._id} onClick={() => this.openConfirmDeleteModal(user)}>
                                                                    <Delete />
                                                                </IconButton>
                                                            </Tooltip>
                                                        </>
                                                    }

                                                </div>
                                            }
                                        ]
                                };
                            })}
                                emptyMessage="No excluded users found"
                                columns={[
                                    {
                                        name: "First Name",
                                        properties:
                                        {
                                            key: 1,
                                            className: "width30pct"
                                        },
                                        sortable: true,
                                        asc: this.state.sort.name === 'asc',
                                        onClick: () =>
                                        {
                                            const order = this.state.sort.firstname === 'asc' ? 'desc' : 'asc'
                                            const orderBy = 'firstname'
                                            this.handleSort({ order, orderBy })
                                        }

                                    },
                                    {
                                        name: "Last Name",
                                        properties:
                                        {
                                            key: 2,
                                            className: "width30pct"
                                        },
                                        sortable: true,
                                        asc: this.state.sort.name === 'asc',
                                        onClick: () =>
                                        {
                                            const order = this.state.sort.lastname === 'asc' ? 'desc' : 'asc'
                                            const orderBy = 'lastname'
                                            this.handleSort({ order, orderBy })
                                        }
                                    },
                                    {
                                        name: "Primary Email",
                                        properties:
                                        {
                                            key: 3,
                                            className: "width40pct"
                                        },
                                        sortable: true,
                                        asc: this.state.sort.email === 'asc',
                                        onClick: () =>
                                        {
                                            const order = this.state.sort.email === 'asc' ? 'desc' : 'asc'
                                            const orderBy = 'email'
                                            this.handleSort({ order, orderBy })
                                        }
                                    },
                                    {
                                        name: "Secondary Email",
                                        properties:
                                        {
                                            key: 4,
                                            className: "width40pct"
                                        },
                                        sortable: true,
                                        asc: this.state.sort.secondary_email === 'asc',
                                        onClick: () =>
                                        {
                                            const order = this.state.sort.secondary_email === 'asc' ? 'desc' : 'asc'
                                            const orderBy = 'secondary_email'
                                            this.handleSort({ order, orderBy })
                                        }
                                    },
                                    {
                                        name: "Employee ID",
                                        properties:
                                        {
                                            key: 5,
                                            className: "width40pct"
                                        },
                                        sortable: true,
                                        asc: this.state.sort.employerKey === 'asc',
                                        onClick: () =>
                                        {
                                            const order = this.state.sort.employerKey === 'asc' ? 'desc' : 'asc'
                                            const orderBy = 'employerKey'
                                            this.handleSort({ order, orderBy })

                                        }
                                    },
                                    {
                                        name: "Exclusion Date",
                                        properties:
                                        {
                                            key: 6,
                                            className: "width40pct"
                                        },
                                        sortable: true,
                                        asc: this.state.sort.censusExclusionDate === 'asc',
                                        onClick: () =>
                                        {
                                            const order = this.state.sort.censusExclusionDate === 'asc' ? 'desc' : 'asc'
                                            const orderBy = 'censusExclusionDate'
                                            this.handleSort({ order, orderBy })

                                        }
                                    },
                                    {
                                        name: "Options",
                                        properties:
                                        {
                                            key: 7,
                                            className: "width40pct"
                                        }
                                    }
                                ]} />
                        </Paper>
                    </div>
                </div>
                <div className='position-absolute'>
                    <Tooltip title="Add user to exclusion list" placement="top" className="floating-button">
                        <Fab onClick={() => this.setState({ add: true })} variant="round" color="primary" aria-label="Add" >
                            <Add />
                        </Fab>
                    </Tooltip>
                </div>
                {/* Modal Area */}
                {this.state.confirmExclusionDelete && this.state.user?._id && < ExclusionDeleteConfirmationModal onCancel={() => this.setState({ confirmExclusionDelete: false, user: null })} loading={this.state.deleting} action={this.delete} />}


                {this.state.add && <AddUserToExclusionModal onCancel={() => this.setState({ add: false, email: null })} loading={this.state.addingUser} action={this.addUser} email={this.state.email} setEmail={(email) => this.setState({ email })} />}
            </div>
        )
    }
}
export default withRouter(connect(null, { showError, showMessage, confirmAction })(Exclusions));